import { CheckCircle2, Circle, CircleDot } from 'lucide-react'
import { PASSING_SCORE } from './content'
import type { LessonState } from './lesson-state'

export function LessonStatusIcon({ state }: { state: LessonState }) {
  if (state === 'done') return <CheckCircle2 className="size-5 shrink-0 text-emerald-600" aria-label="Finished" />
  if (state === 'started') return <CircleDot className="size-5 shrink-0 text-amber-500" aria-label="Started" />
  return <Circle className="size-5 shrink-0 text-muted-foreground/40" aria-label="Not started" />
}

/** "Quiz 100%" in green once passed, amber below the pass mark. */
export function QuizScore({ score }: { score: number | null | undefined }) {
  if (score == null) return null
  const passed = score >= PASSING_SCORE
  return (
    <span
      className={
        passed
          ? 'rounded-full bg-emerald-50 px-2 py-0.5 text-xs font-medium text-emerald-700'
          : 'rounded-full bg-amber-50 px-2 py-0.5 text-xs font-medium text-amber-700'
      }
    >
      Quiz {score}%
    </span>
  )
}
